import React from 'react';
import { Card } from 'react-bootstrap';
import Button from 'components/DesignSystem/Button';
import './index.scss';

export interface AnomalyMapData {
  id: string;
  title: string;
  dataSource: string;
  imageUrl: string;
  period: string;
  anomalyType?: 'precipitation' | 'temperature';
  anomalyValues?: {
    min: number;
    max: number;
  };
}

export interface AnomalyMapProps {
  title: string;
  dataSource: string;
  imageUrl: string;
  onClose: () => void;
  className?: string;
}

export interface AnomalyMapImageParams {
  period: string;
  anomalyType: 'precipitation' | 'temperature';
  region?: string;
}

export interface AnomalyMapTableRow {
  id: string;
  period: string;
  anomalyType: 'precipitation' | 'temperature';
  selected: boolean;
  dataSource?: string;
}

export default function AnomalyMap({
  title,
  dataSource,
  imageUrl,
  onClose,
  className = '',
}: AnomalyMapProps) {
  return (
    <Card className={`anomaly-map-card ${className}`}>
      <Card.Header className="anomaly-map-header">
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="mb-0 anomaly-map-title">{title}</h6>
          <Button
            type="tertiary"
            small
            icon="close"
            onClick={onClose}
            className="anomaly-map-close-btn"
            title="Fechar mapa"
          />
        </div>
      </Card.Header>

      <Card.Body className="p-0">
        <div className="anomaly-map-content">
          <div className="anomaly-map-image-container">
            <img
              src={imageUrl}
              alt={`Mapa de anomalia climática - ${title}`}
              className="anomaly-map-image"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHdpZHRoPSIzMDAiIGhlaWdodD0iMjAwIiBmaWxsPSIjZjVmNWY1IiBzdHJva2U9IiNkZGQiLz4KICAgIDx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBkb21pbmFudC1iYXNlbGluZT0ibWlkZGxlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTQiIGZpbGw9IiM5OTkiPkVycm8gYW8gY2FycmVnYXIgaW1hZ2VtPC90ZXh0Pgo8L3N2Zz4K';
              }}
            />

          </div>

          <div className="anomaly-map-info">
            <small className="text-muted anomaly-map-data-source">
              {dataSource}
            </small>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
